import { Skeleton } from 'antd'

import { cx } from 'antd-style'
import { PropsWithChildren } from 'react'

import { useStyle } from './styles'

import type { SkeletonInputProps } from 'antd/es/skeleton/Input'

type Props = {
  active?: boolean
  height?: number
} & PropsWithChildren &
  SkeletonInputProps

export const SkeletonInputWrapper = ({
  active,
  height,
  className,
  children,
  ...props
}: Props) => {
  const { styles } = useStyle({ height })

  if (active)
    return (
      <Skeleton.Input
        active
        className={cx(styles.skeleton, className)}
        {...props}
      />
    )

  return <div>{children}</div>
}
